import React from 'react';

import PropTypes from 'prop-types';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { CATEGORY_TRANSFER_TO_CASH_UNITELLER } from 'apps/auth/constants/Constants';
import { HELP } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useApp, useCheck, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const PickupPopup = (props) => {
    const cheque = useCheck();
    const { morePopupButtonClose, gotIt, unitellerCashPickupGuideButton, unitellerPickUpGuidLink, unitellerPickUpGuid, unitellerPickUpGuidWorkingHours } =
        usePageMessages();
    const { country } = useApp();
    const { lang } = useLanguage();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;

    const getButtons = (providerToCategory) => {
        if (providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) {
            return (
                <>
                    <PopupButton iconName="arrow-forward" target="_blank" href={unitellerPickUpGuidLink || helpLink} text={unitellerCashPickupGuideButton} />
                    <PopupButton title={gotIt} iconName="check" text={gotIt} onClick={() => props.popupRef.current?.close()} />
                </>
            );
        } else {
            return <PopupButton iconName="check" text={morePopupButtonClose} onClick={() => props.popupRef.current?.close()} />;
        }
    };

    const getText = (cheque = {}) => {
        if (cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) {
            return MarkdownService.splitByParagraph(unitellerPickUpGuid || '', [props.networkName, unitellerPickUpGuidWorkingHours]);
        } else {
            return cheque.toPickupNetwork;
        }
    };

    return (
        <SimplePopup text={getText(cheque)} popupRef={props.popupRef}>
            {getButtons(cheque.providerToCategory)}
        </SimplePopup>
    );
};
PickupPopup.propTypes = {
    networkName: PropTypes.string,
};
export default PickupPopup;
